import { PropTypes } from 'prop-types';
import React from 'react';

import { Box } from '../../grid';
import { Icon } from '../../icons';
import { LoadingIndicator } from '../../icons/loading-indicator';
import { TextInput } from '../../input/text-input';

const AutocompleteInput = ({ autoFocus, loading, getInputProps, onBlur, placeholder, isError, disabled }) => (
  <Box width="100%">
    <TextInput
      {...getInputProps({
        autoFocus,
        placeholder,
      })}
      isError={isError}
      leftIcon={
        <>
          {loading ? <LoadingIndicator size="24px" /> : <Icon name="search" fill="black" width="24px" height="24px" />}
        </>
      }
      name="googleAutocompleteField"
      onBlur={onBlur}
      onKeyDown={null}
      disabled={disabled}
      placeholderColor="black"
    />
  </Box>
);

AutocompleteInput.propTypes = {
  autoFocus: PropTypes.bool,
  getInputProps: PropTypes.func.isRequired,
  isError: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

AutocompleteInput.defaultProps = {
  autoFocus: false,
  loading: false,
  onBlur: undefined,
  disabled: false,
};

export { AutocompleteInput };
